import classnames from "classnames";

import {TooltipWrapper} from "@/components/overlay/TooltipWrapper.tsx";
import {CheckFrequency, MonitoringFrequencyName} from "@/lib/types/devices.ts";

import css from "./PlanRow.module.css";

export interface PlanRowCheckFrequencyProps {
  name: string;
  included: CheckFrequency;
}

export const PlanRowCheckFrequency = ({name, included}: PlanRowCheckFrequencyProps) => {
  return (
    <TooltipWrapper toolTip="The minimum check frequency available for checks. Some advanced checks have higher frequency. See our full Feature Comparison.">
      <div>
        <h2 className={classnames(css.PlanRowHeader, "w-100 text-center fw-semibold fs-5")}>
          {MonitoringFrequencyName[included]}
        </h2>
        <div className="w-100 text-center px-4">
          <div className="w-100 text-center fw-normal">{name}</div>
        </div>
      </div>
    </TooltipWrapper>
  );
};
